import * as yup from 'yup';

export const FarmOrgAccessResponseSchema = yup.object({
  data: yup
    .array(
      yup
        .object({
          id: yup.number().defined(),
          user_type: yup.string().oneOf(['org#member']).defined(),
          user_id: yup.number().defined(),
          role_id: yup.string().oneOf(['viewer', 'editor']).defined(),
          granted_at: yup.string().datetime().defined(),
        })
        .defined(),
    )
    .defined(),
});

export type FarmOrgAccessResponse = yup.InferType<
  typeof FarmOrgAccessResponseSchema
>;

export const AddOrgAccessToFarmResponseSchema = yup.object({
  id: yup.number().defined(),
  user_type: yup.string().oneOf(['org']).defined(),
  user_id: yup.number().defined(),
  org_id: yup.number().defined(),
  role_id: yup.string().oneOf(['viewer', 'editor']).defined(),
  created_at: yup.string().datetime().defined(),
});

export type AddOrgAccessToFarmResponse = yup.InferType<
  typeof AddOrgAccessToFarmResponseSchema
>;
